import { Routes } from '@angular/router';
import { tmaGuard } from './core/guards/tma.guard';
import { msrUnknownGuard } from './core/guards/msr.Unknown.guard';
import { msrInteressentNEWGuard } from './core/guards/msr.InteressentNEW.guard';
import { msrInteressentNOGuard } from './core/guards/msr.InteressentNO.guard';
import { msrClubMemberBasicGuard } from './core/guards/msr.ClubMemberBasic.guard';
import { msrClubMemberProfileGuard } from './core/guards/msr.ClubMemberProfile.guard';
import { msrSUPPORTGuard } from './core/guards/msr.SUPPORT.guard';

export const routes: Routes = [
  {
    path: 'init',
    loadComponent: () =>
      import('./features/init/init.component').then((m) => m.InitComponent),
  },
  {
    path: 'profile',
    loadComponent: () =>
      import('./features/profile/profile.component').then((m) => m.ProfileComponent),
    canActivate: [tmaGuard],
  },
  {
    path: 'questionnaires',
    loadComponent: () =>
      import('./features/questionnaire-list/questionnaire-list.component').then(
        (m) => m.QuestionnaireListComponent,
      ),
    canActivate: [tmaGuard],
  },
  {
    path: 'questionnaires/:qId',
    loadComponent: () =>
      import('./features/questionnaire-run/questionnaire-run.component').then(
        (m) => m.QuestionnaireRunComponent,
      ),
    canActivate: [tmaGuard],
  },
  {
    path: 'msr/unknown',
    loadComponent: () =>
      import('./features/msr/msr-unknown/msr-unknown.component').then(
        (m) => m.MsrUnknownComponent,
      ),
    canActivate: [tmaGuard, msrUnknownGuard],
  },
  {
    path: 'msr/interessent-new',
    loadComponent: () =>
      import('./features/msr/msr-interessent-new/msr-interessent-new.component').then(
        (m) => m.MsrInteressentNEWComponent,
      ),
    canActivate: [tmaGuard, msrInteressentNEWGuard],
  },
  {
    path: 'msr/interessent-no',
    loadComponent: () =>
      import('./features/msr/msr-interessent-no/msr-interessent-no.component').then(
        (m) => m.MsrInteressentNOComponent,
      ),
    canActivate: [tmaGuard, msrInteressentNOGuard],
  },
  {
    path: 'msr/club-member-basic',
    loadComponent: () =>
      import('./features/msr/msr-club-member-basic/msr-club-member-basic.component').then(
        (m) => m.MsrClubMemberBasicComponent,
      ),
    canActivate: [tmaGuard, msrClubMemberBasicGuard],
  },
  {
    path: 'msr/club-member-profile',
    loadComponent: () =>
      import('./features/msr/msr-club-member-profile/msr-club-member-profile.component').then(
        (m) => m.MsrClubMemberProfileComponent,
      ),
    canActivate: [tmaGuard, msrClubMemberProfileGuard],
  },
  {
    path: 'msr/support',
    loadComponent: () =>
      import('./features/msr/msr-support/msr-support.component').then(
        (m) => m.MsrSupportComponent,
      ),
    canActivate: [tmaGuard, msrSUPPORTGuard],
  },
  { path: '', redirectTo: 'init', pathMatch: 'full' },
  { path: '**', redirectTo: 'init' },
];
